import { render } from "./CaricaLettureFile.vue?vue&type=template&id=613c52a9&scoped=true"
import script from "./CaricaLettureFile.vue?vue&type=script&lang=js"
export * from "./CaricaLettureFile.vue?vue&type=script&lang=js"

import "./CaricaLettureFile.vue?vue&type=style&index=0&id=613c52a9&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613c52a9"]])

export default __exports__